import AddIcon from './component.jsx'
export default AddIcon
